import React from 'react';
import styled from 'styled-components';
import { css } from 'styled-components';

const styleForArrowButton = css`
  position: relative;
  width: 140px;
  padding: 8px 12px 8px 30px;
  line-height: 16px;
  font-size: 12px;
`;

const afterStyleForArrow = css`
  &:after {
    position: absolute;
    display: block;
    content: '';
    width: 7px;
    height: 7px;
    top: 0;
    left: 15px;
    bottom: 0;
    margin-top: 12px;
    border-right: 1px solid rgba(0, 0, 0, 0.4);
    border-bottom: 1px solid rgba(0, 0, 0, 0.4);
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(135deg);
  }
`;

const StyledButton = styled.button(
  (props: {
    arrow?: boolean;
    disabled?: boolean;
    isSharpBorder?: boolean;
    isLeftAlign?: boolean;
  }) => `
  display: inline-block;
  margin-bottom: 0;
  text-align: ${props.isLeftAlign ? 'left' : 'center'};
  vertical-align: middle;
  touch-action: manipulation;
  user-select: none;
  border: 1px solid transparent;
  padding: 0px 12px;
  line-height: 20px;
  ${props.arrow ? '' : 'min-height: 48px;'}
  position: relative;
  background-color: #fff; 
  color: #333;
  border-color: rgba(0, 0, 0, 0.2); 
  border-radius:${props.isSharpBorder ? '4px' : '22px'};
  text-decoration: none;
  font-size: 14px;
  word-break: break-all;

  &:hover {
    ${props.disabled ? '' : 'opacity: 0.7;'}
  }
  ${props.arrow ? styleForArrowButton : ''}

  ${props.arrow ? afterStyleForArrow : ''}

  ${props.disabled ? '' : 'cursor: pointer;'}
  ${props.disabled ? 'color: #ccc; border-color: #ccc;' : ''}
  p { 
    ${props.disabled ? 'color: #ccc;' : ''}
  }`,
);

interface Props {
  children: any;
  onClick: any;
  style?: Record<string, any>;
  arrow?: boolean;
  disabled?: boolean;
  isSharpBorder?: boolean;
  isLeftAlign?: boolean;
}

export const RoundedButton = (props: Props) => {
  const {
    children,
    onClick,
    style,
    arrow,
    disabled,
    isSharpBorder,
    isLeftAlign,
  } = props;

  return (
    <StyledButton
      type="button"
      onClick={onClick}
      style={style}
      arrow={arrow}
      disabled={disabled}
      data-testid="roundBtn"
      isSharpBorder={isSharpBorder}
      isLeftAlign={isLeftAlign}
    >
      {children}
    </StyledButton>
  );
};
